import MqUtils from '../common/utils/mq.es6';
import ArrUtils from '../common/utils/arr.es6';
import AnimeUtils from '../common/utils/anime.es6';

export default class SubMv {
    constructor(main) {
        this.main = main;

        this.$subMv = {
            canvas: document.querySelector('.js-canvas'),
            explode1: document.querySelector('.js-sub_mv__explode1'),
            explode2: document.querySelector('.js-sub_mv__explode2'),
            box: document.querySelector('.js-sub_mv__box'),
            logo: document.querySelector('.js-sub_mv__logo'),
            date: document.querySelector('.js-sub_mv__date'),
            stickers: [...document.querySelectorAll('.js-sub_mv__sticker')],
            slide: document.querySelector('.js-sub_kv__slide'),
        };
    }

    setAnimate() {
        const hasAllEls = Object.entries(this.$subMv).every(([key, $el]) => {
            if (key === 'stickers') return $el.length;
            return $el;
        });

        // SP幅または全要素を取得できていない場合、実行不可
        if (MqUtils.getMq('narrow', 'max').matches || !hasAllEls) return;

        const animations = {
            canvas: AnimeUtils.getOutBack(this.$subMv.canvas, 10, 2400, 1800),
            explode1: AnimeUtils.getBounce(this.$subMv.explode1, 60, 1200, 1000),
            explode2: AnimeUtils.getOutBack(this.$subMv.explode2, 60, 1200, 1400),
            box: AnimeUtils.getBox(this.$subMv.box, 1600, 400),
            logo: AnimeUtils.getBounce(this.$subMv.logo, 80, 1200, 1200),
            date: AnimeUtils.getBounce(this.$subMv.date, 40, 1200, 1400),
            slide: AnimeUtils.getOutBack(this.$subMv.slide, 20, 1200, 1800),
        };

        // ステッカーはシャッフルしてから、アニメーションを実行
        ArrUtils.getShuffleArr(this.$subMv.stickers).forEach(($sticker, i) => {
            const delay = 1200 + i * 50;
            animations[`sticker${i + 1}`] = AnimeUtils.getOutBack($sticker, 40, 1200, delay);
        });

        animations.logo.onfinish = () => this.main.mainMv.setAnimationEnd();
    }
}
